/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import { isMobile } from "react-device-detect";

export default function Header({
  CompanyId,
  OperatorId,
  ProjectId,
  ProjectData,
  title,
  children,
}) {
  return (
    <>
      <div
        className="row"
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        {/* <div className="d-flex align-content-center flex-wrap mr-auto">
          <img
            src={Api.absoluteUrl("/icon/bbtec/header/MA-List.svg")}
            alt={title}
            title={title}
          />
          <h2>
            {title} / {ProjectData[0]?.project_name}
          </h2>
        </div> */}

        {/* <div className="col-sm-auto col-lg-6"> */}
        {/* <div className="d-flex align-items-center mr-auto">
          <img
            src={Api.absoluteUrl("/icon/bbtec/header/MA-List.svg")}
            className="mr-3"
            alt={title}
            title={title}
            style={{ height: 20 }}
          />
          <h3
            className="c-white text-uppercase mr-auto mt-0 mb-0"
            style={{ fontFamily: "ThaiSansB" }}
          >
            {title} / {ProjectData[0]?.project_name}
          </h3>
        </div> */}
        {children}

        {/* {!isMobile && (
          <div className="">
            <a
              href={Api.absoluteUrl("")}
              className="btn btn-sm btn-map"
              style={{ padding: "0px 10px !important", height: 30 }}
            >
              <img src={Api.absoluteUrl("/icon/map.svg")} />
              <span>Map</span>
            </a>
          </div>
        )} */}
      </div>
    </>
  );
}
